module.exports = __webpack_public_path__ + "media/images/covid/banner/zh-hans-5a6708272e9b8db5adbc890c3a068b7c.jpg";